<template>
  <div class="monitor-page">
    <div class="snapshot-viewer" v-if="snapshotViewerEnabled">
      <div class="options">
        <button class="btn"><i class="fa fa-star"></i> favorite</button>
        <button class="btn btn-primary" v-on:click.prevent="snapshotViewerEnabled = false"><i class="fa fa-times"></i> close</button>
      </div>

      <div class="image-container">
        <img style="max-width: 100%;" :src="imagePath" />
      </div>
    </div>
    <div v-else>
      <MonitorForm :id="$route.params.id"></MonitorForm>
    </div>

  </div>
</template>

<script>
import API from "../api"
import MonitorForm from "../components/MonitorForm.vue"

export default {
  name: 'monitor-page',
  data () {
    return {
      checks: [],
      snapshotViewerEnabled: false,
      imagePath: false
    }
  },
  components: {
    MonitorForm
  },
  watch: {
      '$route': function(){
        this.fetchChecks(this.$route.params.id)
      }
  },
  created() {
    this.fetchChecks(this.$route.params.id)
  },
  methods: {
    checkModal() {
      this.$modal.show('hello-world', { notificator_id: 'test'});
    },
    // fetch the latest requests for this check
    fetchChecks(id) {
        var that = this;
        API.get(`/monitors/${id}/checks`).then(function (response) {
            if(response.data.OK) {
                that.checks = response.data.Checks
            }
        })
    },
    showSnapshot(id) {
      // window.open (``,'_blank',false)
      this.imagePath = `https://snapshots.nyc3.digitaloceanspaces.com/${id}.png`
      this.snapshotViewerEnabled = true;
    }
  },
  computed: {
    countChecks() {
      return this.checks.length
    }
  }
}
</script>

<style lang="scss">

.checks-graph {
  transition: all .2s ease;
  overflow: hidden;
  height: 45px;

  li {
    list-style: none;
    display: inline-block;
    width: 11px;
    height: 42px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    border-radius: 2px;
    margin: 0;
    border: 1px solid #fff;
    float: left;

    &:hover {
      border-color: #b9cff3;
      cursor: pointer;

      &.changed {
        border-color: #78bb00;
        box-shadow: 0px 1px 0px #fff inset;
      }
    }

    &.changed {
      background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);
    }
  }
}
.checks-list {
  margin: 0; padding: 0;
  background: #fff;

  li {
    background: #fff;
    list-style: none;
    border: 1px solid #00a9ff;
    margin: 6px 0;
    border-radius: 2px;
  }
}

.checks-tooltip {
  display: flex;
  flex: 1;

  .website-screenshot {
    width: 40%;
    display: block;
    float: left;
  }

  ul {
    font-size: 12px;
    margin-right: auto;
    flex: 1;
    display: block;
    padding: 3px;

    li {
      list-style: none;
    }
  }
}

.snapshot-viewer {
  .options {
    background: #ecf7ff;
    padding: 5px;
    border-radius: 4px;
    margin: 12px 0px;
    text-align: right;
  }

  .image-container {
    text-align: center;

    img {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MonitorPage.vue